import Text from "../Text/Text";

export const EmptyState: React.FC<{
    message: string;
    subMessage?: string;
  }> = ({ message, subMessage }) => {
    return (
      <div className="empty-state">
        <div className="empty-icon">
          <svg viewBox="0 0 24 24" width="48" height="48" stroke="#6c757d" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="3" y1="9" x2="21" y2="9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="9" y1="21" x2="9" y2="9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <Text className="text-body">{message}</Text>
        {subMessage && (
          <Text className="text-caption text-gray">
            {subMessage}
          </Text>
        )}
      </div>
    );
  };